import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import LogoPauseImage from '../components/pages/waiting-area/logo-pause-image/content';

function WaitingAreaLogoPauseImagePage(props) {
  const waitingAreaLogoPauseImageForm = useSelector((state) => state.waitingAreaReducer.waitingAreaLogoPauseImageForm);
  const showWaitingAreaLogoPauseImageModal = useSelector(
    (state) => state.modalReducer.showWaitingAreaLogoPauseImageModal
  );
  const dispatch = useDispatch();

  return (
    <div>
      <LogoPauseImage
        dispatch={dispatch}
        waitingAreaLogoPauseImageForm={waitingAreaLogoPauseImageForm}
        waitingArea={props.waitingArea}
        showWaitingAreaLogoPauseImageModal={showWaitingAreaLogoPauseImageModal}
        readOnly={props.readOnly}
      />
    </div>
  );
}

export default WaitingAreaLogoPauseImagePage;
